// @ts-nocheck
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";

export const orderSubtitleSpacingStyles = () => spacingStyles(null, pxToRem(16));
